module.exports = __webpack_public_path__ + "media/country_flags/wf-0772806c.png";